module.exports = __webpack_public_path__ + "img/835984_39273A_4C334C_593D5A-256px.ffd5ae76.png";